import { Paper, CardContent, Stack, Grid, Select, MenuItem, Avatar, Typography } from "@mui/material";
import { useAtom, useSetAtom } from "jotai";
import { useState } from "react";
import { LoadingAtom, PredictDataAtom, PredictResponse, User } from "../Atoms";
import { green, pink, red } from "@mui/material/colors";


const USERS: User[] = [
  {
    name: "홍길동",
    age: 30,
    loan_term: 12,
    requested_loan: 50000000,
    credit_score: 4,
    annual_income: 60000000,
    debt: 20000000,
    bgcolor: green[500],
  },
  {
    name: "김철수",
    age: 65,
    loan_term: 24,
    requested_loan: 16000000,
    credit_score: 1,
    annual_income: 60000000,
    debt: 0,
    bgcolor: pink[500],
  },
];


async function getPredictData(user: User) {
  const res = await fetch("http://168.107.30.106/papi/predict", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
    credentials: "include",
  });

  if (!res.ok) {
    throw new Error(`HTTP error! status: ${res.status}`);
  }

  const data: PredictResponse = await res.json();
  return data;
}


export default function LoanCard() {
  const [userIdx, setUserIdx] = useState<number>(-1);
  const setLoading = useSetAtom(LoadingAtom)
  const [predictData, setPredictData] = useAtom(PredictDataAtom)
  const danger = (predictData?.prediction ?? 0) > 0.5
  const onUserChange = async (index: number) => {
    setUserIdx(index);
    const user = USERS[index];
    console.log("선택된 사용자:", index, user);
    setLoading(true);
    try {
      const data = await getPredictData(user);
      setPredictData(data);
    } catch (error) {
      alert("예측 중 오류가 발생했습니다.");
    } finally {
      setLoading(false);
    }
  };
  return <Paper sx={{ height: "100%" }} elevation={12}>
    <CardContent>
      <Stack direction={"column"} spacing={2}>
        <Grid>
          <Stack direction={"row"} spacing={1} alignItems="start">
            <Select
              size={"small"}
              sx={{ width: "100%" }}
              value={userIdx}
              onChange={(e) => onUserChange(e.target.value as number)}
            >
              <MenuItem disabled value={-1} sx={{ width: "100%" }}>
                <em>테스트 데이터 - 선택하세요</em>
              </MenuItem>
              {USERS.map((user, index) => (
                <MenuItem
                  key={index}
                  value={index}
                  sx={{ width: "100%" }}
                >
                  <Stack direction={"row"}>
                    <Avatar
                      sx={{
                        width: 24,
                        height: 24,
                        bgcolor: user.bgcolor,
                        mr: 1,
                      }}
                    >
                      {user.name.charAt(0)}
                    </Avatar>
                    <Typography variant="caption">
                      {`${user.age}세, ${user.credit_score
                        }등급, 연소득 ${(
                          user.annual_income / 10000
                        ).toLocaleString()}만원, 부채: ${user.debt === 0
                          ? "없음"
                          : `${(
                            user.debt / 10000
                          ).toLocaleString()}만원`
                        }`}
                    </Typography>
                  </Stack>
                </MenuItem>
              ))}
            </Select>
          </Stack>
        </Grid>
        <Grid container spacing={2}>
          <Stack direction={"column"} spacing={1}>
            <Typography
              variant="h5"
              fontWeight={"bold"}
              color={danger ? red[500] : green[500]}
            >
              {predictData && (
                `연체 가능성: ${danger ? "높음" : "낮음"}(${predictData.prediction * 100}%)`
              )}

            </Typography>
            <Typography variant="h6">
              {predictData && predictData.chu.max > -1
                ? `추천 대출: ₩${predictData.chu.max.toLocaleString()}`
                : ""}
            </Typography>
            <Typography variant="body2" color={danger ? 'warning' : 'success'}
              sx={{ whiteSpace: 'pre-line' }}>
              {(predictData?.advice ?? '')}
            </Typography>
          </Stack>
        </Grid>
      </Stack>
    </CardContent>
  </Paper>
}